import React, { FC } from 'react';
import { Switch, useRouteMatch, Route, Redirect } from 'react-router-dom';
import { useRole } from 'roles/useRole';

// TODO: this will need to be refactored when we'll have real role management
// atm the only roles that can see the platform are company and company_alias
const ManageCompanyRedirects: FC<{ redirectTo: string }> = ({ redirectTo }) => {
  const { path } = useRouteMatch();
  const { showAdmin, showCompany } = useRole();
  return (
    <Switch>
      <Route exact path={`${path}`}>
        {!showAdmin && !showCompany && <Redirect to={redirectTo} />}
      </Route>
    </Switch>
  );
};

export { ManageCompanyRedirects };
